import { Route, Routes } from "react-router-dom";
import MainDashboard from "../dashboard";
import { FreeCustomerClub } from "../pages/UserPages/CustomerClub/FreeCustomerClub";
import FeedbackApp from "../feedback";
import Scan from "../scanner";
import MainPanel from "../layouts/mainPanel";
import SurveyResponse from "../pages/SurveyResponse";
import ContentPublicPage from "../features/content-studio/ContentPublicPage";
import AuthPage from "../pages/Auth";
import { usePanelRoutes } from "./PanelRoutes";

function AppRoutes() {
    const panelRoutes = usePanelRoutes();

    return (
        <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/" element={<MainDashboard />} />
            <Route path="/:id" element={<MainDashboard />} />
            <Route
                path="/content/share/:id"
                element={<FreeCustomerClub />}
            />
            <Route path="/content/:token" element={<ContentPublicPage />} />
            <Route path="/feedback/*" element={<FeedbackApp />} />
            <Route path="/survey/:token" element={<SurveyResponse />} />
            <Route
                path="/scanner"
                element={
                    <Scan
                        scanRate={250}
                        covid19={true}
                        upnqr={true}
                        beep={true}
                    />
                }
            />
            <Route path="/dashboard/*" element={<MainPanel />}>
                {panelRoutes}
            </Route>
        </Routes>
    );
}

export default AppRoutes;
